export default __webpack_public_path__ + "static/media/28_1_21_LegalisierungJetzt_PresseKonferenz.96a7ea7c.pdf";